import {DropdownSelect, DropdownSelectText} from "@reside/ui";
import {Status} from "./utils/types";
import {STATUSES} from "./utils/constants";

export const StatusFilterDropdown = ({
  admissionStatus,
  onStatusSelect,
}: {
  admissionStatus: Status;
  onStatusSelect: (item: Status) => void;
}) => (
  <DropdownSelect
    trigger={({isOpened}) => (
      <DropdownSelectText isOpened={isOpened} label={admissionStatus.label} />
    )}
    selectItem={onStatusSelect}
    selectedItem={admissionStatus}
    items={STATUSES as Status[]}
    label="Status"
  />
);
